/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountPaginationResponseAllOfDataInner } from './AccountPaginationResponseAllOfDataInner';
import {
    AccountPaginationResponseAllOfDataInnerFromJSON,
    AccountPaginationResponseAllOfDataInnerFromJSONTyped,
    AccountPaginationResponseAllOfDataInnerToJSON,
    AccountPaginationResponseAllOfDataInnerToJSONTyped,
} from './AccountPaginationResponseAllOfDataInner';

/**
 * 
 * @export
 * @interface AccountListResponse
 */
export interface AccountListResponse {
    /**
     * アカウント情報の一覧
     * @type {Array<AccountPaginationResponseAllOfDataInner>}
     * @memberof AccountListResponse
     */
    accounts: Array<AccountPaginationResponseAllOfDataInner>;
}

/**
 * Check if a given object implements the AccountListResponse interface.
 */
export function instanceOfAccountListResponse(value: object): value is AccountListResponse {
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    return true;
}

export function AccountListResponseFromJSON(json: any): AccountListResponse {
    return AccountListResponseFromJSONTyped(json, false);
}

export function AccountListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accounts': ((json['accounts'] as Array<any>).map(AccountPaginationResponseAllOfDataInnerFromJSON)),
    };
}

export function AccountListResponseToJSON(json: any): AccountListResponse {
    return AccountListResponseToJSONTyped(json, false);
}

export function AccountListResponseToJSONTyped(value?: AccountListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accounts': ((value['accounts'] as Array<any>).map(AccountPaginationResponseAllOfDataInnerToJSON)),
    };
}

